<div class="p-keep-my-fare__box is-open">
  <!-- [SP版] -->
  <ng-container *ngIf="isSP; else mergeNotSP">
    <!-- [タイトル] -->
    <div class="p-keep-my-fare__title">
      <span class="c-flight-info01__title" [innerHTML]="'label.margeAllPlansToMembersPlanList' | staticMsg"></span>
    </div>
    <!-- [//タイトル] -->

    <!-- [説明文言] -->
    <div class="p-sky-coins__use-input">
      <p [innerHTML]="'label.margeAllPlansToExplain' | staticMsg"></p>
    </div>
    <!-- [//説明文言] -->

    <!-- [マージボタン] -->
    <div class="merge-info__login-button">
      <button
        id="plan-list-merge-info-login-button-1"
        class="c-btn-secondary c-btn-secondary--s merge-info__login-button"
      >
        <span
          class="c-btn-secondary__text merge-info__merge-button-text"
          [innerHTML]="'label.marge' | staticMsg"
          (click)="openLoginModal()"
        ></span>
      </button>
    </div>
    <!-- [//マージボタン] -->
  </ng-container>
  <!-- [//SP版] -->

  <!-- [PC、TAB版] -->
  <ng-template #mergeNotSP>
    <table class="p-family-miles__table">
      <!-- [タイトル] -->
      <tr>
        <div class="p-keep-my-fare__title">
          <span class="c-flight-info01__title" [innerHTML]="'label.margeAllPlansToMembersPlanList' | staticMsg"></span>
        </div>
      </tr>
      <!-- [//タイトル] -->

      <tr>
        <!-- [説明文言] -->
        <td>
          <div class="p-sky-coins__use-input">
            <p [innerHTML]="'label.margeAllPlansToExplain' | staticMsg"></p>
          </div>
        </td>
        <!-- [//説明文言] -->

        <!-- [マージボタン] -->
        <td>
          <div class="p-select-flight-panel02__move-btn p-terms-conditions__list">
            <button
              id="plan-list-merge-info-login-button-2"
              class="c-btn-secondary c-btn-secondary--s merge-info__login-button"
            >
              <span
                class="c-btn-secondary__text merge-info__merge-button-text"
                [innerHTML]="'label.marge' | staticMsg"
                (click)="openLoginModal()"
              >
              </span>
            </button>
          </div>
        </td>
        <!-- [//マージボタン] -->
      </tr>
    </table>
  </ng-template>
  <!-- [//PC、TAB版] -->
</div>
